<div
  *ngIf="filter && !disableStickyHeader"
  dgxSticky
  [stickyCustomClass]="'box-shadow guts-p-full-1 bg-color-ebony-a03-hue'"
  [notStickyCustomClass]="'grid__col-12 guts-p-v-0'"
>
  <ng-container *ngTemplateOutlet="profileFilter"></ng-container>
</div>

<div *ngIf="filter && disableStickyHeader" class="grid__col-12 guts-p-v-0">
  <ng-container *ngTemplateOutlet="profileFilter"></ng-container>
</div>

<ng-template #profileFilter>
  <div class="container">
    <dgx-data-search
      [minLength]="minSearchLength"
      [placeholder]="placeholder"
      [searchTerm]="filter.searchTerm"
      type="short"
      (doSearch)="search($event)"
    ></dgx-data-search>
    <div class="l_flexbar full-width m-guts-p-t-1">
      <div *ngIf="includeDefaultFilters">
        <dgx-search-filters
          [defaultFilterIds]="defaultFilterIds"
          [filters]="searchFilters"
          [hasSearchTerm]="!!filter.searchTerm"
          (filtersChange)="applyFilters($event)"
          (clearSearchTerm)="search('')"
        ></dgx-search-filters>
      </div>
      <div *ngIf="!includeDefaultFilters">
        <dgx-search-filters
          [filters]="searchFilters"
          [hasSearchTerm]="!!filter.searchTerm"
          (filtersChange)="applyFilters($event)"
          (clearSearchTerm)="search('')"
        ></dgx-search-filters>
      </div>
      <div class="l_flex--align-right guts-p-r-half">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</ng-template>
